// extracted by mini-css-extract-plugin
module.exports = {"message":"FailMessage__message___O31qI"};